"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircuitBreakerState = void 0;
/**
 * Enumeration with all states a circuit breaker can be in.
 */
var CircuitBreakerState;
(function (CircuitBreakerState) {
    /**
     * The circuit breaker is open, all requests will fail with a CircuitBreakerError.
     */
    CircuitBreakerState["Open"] = "Open";
    /**
     * One request will be allowed to pass the circuit breaker to determine if the depended resource is available.
     */
    CircuitBreakerState["HalfOpen"] = "HalfOpen";
    /**
     * The circuit breaker is open, requests are executed.
     */
    CircuitBreakerState["Close"] = "Close";
})(CircuitBreakerState = exports.CircuitBreakerState || (exports.CircuitBreakerState = {}));
//# sourceMappingURL=circuitBreakerState.js.map